'use client'

import { forwardRef, HTMLAttributes } from 'react'
import clsx from 'classnames'
import { motion } from 'framer-motion'
import { ScrollArea } from '@/shared/ui/scroll-area/scroll-area'
import { useAppearance } from '@/shared/utils'
import { variantsHeadline } from '@/shared/constants/variants'
import { EditorJsTableBlock, IEditorJsDocument } from '@/interfaces/common'
import style from './table.module.scss'

interface TableProps extends HTMLAttributes<HTMLDivElement> {
  text: string
  tableTitle: string | null
  tableEditorjs: IEditorJsDocument
}

export const Table = forwardRef<HTMLDivElement, TableProps>((props, ref) => {
  const { className, text, tableTitle, tableEditorjs } = props
  const { ref: innerRef, animate } = useAppearance(ref)
  const tableBlock =
    tableEditorjs?.blocks.find((block: any): block is EditorJsTableBlock => block.type === 'table') || null

  return (
    <div>
      {tableTitle && <div className={clsx(style.tableTitle, 'mb-32')}>{tableTitle}</div>}
      <div className={style.section}>
        <ScrollArea type="always">
          <>
            <div id="editorjs"></div>
          </>
          {tableBlock ? (
            <div className={clsx(style.container, className, 'text text_color_dark richText')}>
              <table>
                <tbody>
                  {tableBlock?.data?.content.map((row, rowIndex) => (
                    <tr key={rowIndex}>
                      {row.map((cell, cellIndex) => {
                        const isHeader = tableBlock?.data?.withHeadings && rowIndex === 0

                        return isHeader ? <th key={cellIndex}>{cell}</th> : <td key={cellIndex}>{cell}</td>
                      })}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          ) : (
            <motion.div
              ref={innerRef}
              animate={animate}
              variants={variantsHeadline}
              className={clsx(style.container, className, 'text text_color_dark richText')}
              dangerouslySetInnerHTML={{ __html: text ?? '' }}
            />
          )}
        </ScrollArea>
        <div className={style.overlay}></div>
      </div>
    </div>
  )
})

Table.displayName = 'Table'
